
import { Component, Prop, PropSync, Vue } from 'vue-property-decorator';
import QvInput from '@/components/FormComponents/QvInput.vue';
import QvSelect from '@/components/FormComponents/QvSelect.vue';
import { ValidationObserver } from 'vee-validate';
import { BlockStore, CommonStore, FarmStore } from '@/store/modules';
import { Geom } from '@/store/models/map';
import { Coordinate } from 'ol/coordinate';

import GeoJSON from 'ol/format/GeoJSON';

import { Map } from 'ol';
import { Extent, getCenter } from 'ol/extent';
import { SelectedFarmBlock } from '@/store/models/common';

@Component({
  components: {
    QvInput,
    QvSelect,
    ValidationObserver
  }
})
export default class SearchFarmForm extends Vue {
  $refs!: {
    observer: InstanceType<typeof ValidationObserver>;
  };

  @Prop({ default: false })
  setSelectedFarmBlock!: boolean;

  @Prop({ required: true })
  map!: Map;

  @PropSync('searchFarmDialog', { default: false, required: true })
  syncedSearchFarmDialog!: boolean;

  farmId: null | number = null;

  blockId: null | number = null;

  selectedFarmBlock: SelectedFarmBlock = {
    farmId: 0,
    name: '',
    center: [150.5155619, -23.322713]
  } as SelectedFarmBlock;

  get blockOptions() {
    if (!this.farmId) {
      return [];
    }
    const blockList = BlockStore.GeomBlocks.filter(x => x.farm == this.farmId);
    const blocks: {
      label: string;
      farmId: number;
      farmName: string;
      value: null | number;
      polygonGeom: Geom | string;
    }[] = blockList.map(x => {
      return {
        label: x.name,
        farmId: x.farm,
        farmName: x.farmName,
        value: x.id,
        polygonGeom: x.polygonGeom
      };
    });
    return blocks;
  }

  get farms() {
    return FarmStore.Farms.map(x => {
      return {
        value: x.id,
        label: x.name,
        pointGeom: x.pointGeom,
        envelope: x.envelope
      };
    });
  }
  zoomPosition: null | Coordinate = null;

  onFarmSelect(farmId: number) {
    const farm = this.farms.find(x => x.value == farmId);
    BlockStore.getAllMyBlocksWithGeom({
      farm: farmId
    });
    if (farm && farm.pointGeom) {
      this.farmId = farmId;
      this.blockId = null;
      if (typeof farm.pointGeom != 'string') {
        this.zoomPosition = farm.pointGeom.coordinates as Coordinate;
        let extent: Extent | null = null;
        if (farm.envelope) {
          const geometry = new GeoJSON().readGeometry(farm.envelope);
          extent = geometry.getExtent();
        }
        this.selectedFarmBlock = {
          farmId: farm.value,
          name: farm.label,
          blockName: undefined,
          center: this.zoomPosition as Coordinate,
          extent: extent
        };
        return;
      }
    }
    this.zoomPosition = null;
  }

  clearBlock() {
    this.selectedFarmBlock.blockName = undefined;
    this.selectedFarmBlock.blockId = undefined;
  }

  onBlockSelect(blockId: number) {
    const block = this.blockOptions.find(x => x.value == blockId);
    if (block && block.polygonGeom) {
      this.blockId = blockId;
      if (typeof block.polygonGeom != 'string') {
        const geom = new GeoJSON({
          dataProjection: 'EPSG:4326',
          featureProjection: 'EPSG:3857'
        }).readFeature(block.polygonGeom);
        const geometry = geom.getGeometry();
        if (geometry) {
          const extent = geometry.getExtent();
          const center = getCenter(extent);
          this.zoomPosition = center;
          this.selectedFarmBlock = {
            farmId: block.farmId,
            blockId: block.value,
            name: block.farmName,
            blockName: `${block.label}`,
            center: this.zoomPosition as Coordinate,
            extent: extent
          };
          return;
        }
      }
    }
    this.zoomPosition = null;
  }

  async onSubmit() {
    if (this.zoomPosition) {
      if (this.setSelectedFarmBlock) {
        await CommonStore.setSelectedFarmBlock(this.selectedFarmBlock);
      }
      this.$emit('zoomToPosition', this.zoomPosition);
    }
  }
  onReset() {
    requestAnimationFrame(() => {
      this.$refs.observer.reset();
    });
  }

  created() {
    FarmStore.getAllMyFarms();
  }
}
